let _loading;

export function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve(true);
  if (_loading) return _loading;
  _loading = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => { _loading = null; resolve(false); };
    document.body.appendChild(s);
  });
  return _loading;
}

export async function openRazorpayCheckout({ orderData, onSuccess, onDismiss, onError }) {
  const ok = await loadRazorpay();
  if (!ok) { onError && onError(new Error("Failed to load Razorpay checkout")); return; }
  const rzp = new window.Razorpay({
    key: orderData.key_id,
    order_id: orderData.order_id,
    amount: orderData.amount,
    currency: orderData.currency,
    name: orderData.name || "Code With Sankalp",
    description: orderData.description || "",
    prefill: orderData.prefill || {},
    theme: { color: "#f59e0b" },
    handler: (resp) => onSuccess && onSuccess(resp),
    modal: { ondismiss: () => onDismiss && onDismiss() },
  });
  rzp.on && rzp.on("payment.failed", (resp) => onError && onError(resp));
  rzp.open();
}
